module.exports = __webpack_public_path__ + "img/dkh_banner.f59025af.png";